import React, {SVGProps} from 'react'

interface Props {
  props?: SVGProps<SVGSVGElement>
}

const BigIconSuccess = (props: Props) => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M35.5034 34.5961C35.6531 34.1763 35.8628 33.792 36.1352 33.4478C37.6813 31.4827 40.9503 31.2145 44.9898 32.3554M35.5034 34.5961L24.12 78.5806C23.4656 81.1092 26.1309 83.2083 28.4357 81.9796L68.4485 60.6484M35.5034 34.5961C34.2315 38.1622 37.2902 44.2842 43.0792 50.0342M68.4485 60.6484C68.8174 60.4078 69.1391 60.118 69.4084 59.7777C70.9736 57.7883 70.4521 54.4677 68.3472 50.7308M68.4485 60.6484C65.1795 62.7806 58.1999 61.0522 51.0413 56.4338M49.3164 55.2667C48.6043 54.7622 47.8933 54.2299 47.1867 53.6707C46.3331 52.9953 45.5161 52.3044 44.7387 51.6037M49.3164 55.2667C49.8913 55.674 50.4669 56.0632 51.0413 56.4338M49.3164 55.2667C52.3445 53.1871 58.7283 49.8329 66.4965 47.8874M51.0413 56.4338C55.9305 53.432 62.4593 51.6876 68.3472 50.7308M43.0792 50.0342C43.6098 50.5612 44.1634 51.0852 44.7387 51.6037M43.0792 50.0342C44.4006 45.7138 45.8116 38.387 44.9898 32.3554M44.7387 51.6037C47.6743 44.2968 48.7135 38.3712 48.6643 33.6916M63.9622 36.487C63.2905 34.23 62.35 29.5386 63.9622 28.8293C65.9774 27.9426 68.5569 33.5045 70.8139 32.2148C73.0709 30.9251 69.4435 27.7814 70.8139 25.2019C72.1842 22.6224 79.6002 28.4262 81.2123 23.4285C82.502 19.4304 79.7614 16.6574 78.2298 15.7708M66.4965 47.8874C70.7697 46.8171 75.462 46.1731 80.2449 46.4019L80.2449 49.7068C77.5329 49.6936 73.1535 49.9498 68.3472 50.7308M66.4965 47.8874C64.45 45.1054 61.6564 42.2264 58.3003 39.5859C55.0633 37.039 51.7429 35.0416 48.6643 33.6916M48.6643 33.6916C48.5822 25.8794 45.4671 21.5396 43.0792 20.043L39.941 23.4285C42.9851 25.0774 44.4569 28.4441 44.9898 32.3554"
        stroke="#7B8CA8"
        strokeWidth="1.2"
      />
      <path
        d="M32.2094 47.3001C31.0515 50.5465 34.6857 56.6214 40.9597 61.5862C47.2404 66.5562 53.9958 68.696 56.8839 66.8122"
        stroke="#7B8CA8"
        strokeWidth="1.2"
      />
      <path
        d="M28.8867 60.1903C28.1245 62.3275 30.5169 66.3267 34.6472 69.595C38.7818 72.8669 43.229 74.2755 45.1303 73.0354"
        stroke="#7B8CA8"
        strokeWidth="1.2"
      />
      <path
        d="M26.2718 70.2225C25.8147 71.5039 27.2491 73.9016 29.7254 75.8611C32.2044 77.8228 34.8707 78.6673 36.0106 77.9238"
        stroke="#7B8CA8"
        strokeWidth="1.2"
      />
      <path
        d="M28.0529 44.1724C29.5354 43.1981 32.3735 40.6904 31.8652 38.4538C31.2298 35.6581 22.8425 38.9622 22.7155 36.5477C22.5884 34.1331 27.0361 30.575 26.909 28.6688C26.7819 26.7626 18.6489 30.8291 18.6489 26.8896C18.6489 23.738 21.36 22.1029 22.7155 21.6793"
        stroke="#7B8CA8"
        strokeWidth="1.2"
      />
      <rect
        x="21.8833"
        y="50.1122"
        width="3.03077"
        height="3.03077"
        transform="rotate(-24.7154 21.8833 50.1122)"
        stroke="#7B8CA8"
        strokeWidth="1.2"
      />
      <rect
        x="16.0527"
        y="36.722"
        width="3.03077"
        height="3.03077"
        transform="rotate(4.36851 16.0527 36.722)"
        stroke="#7B8CA8"
        strokeWidth="1.2"
      />
      <rect
        x="27.9448"
        y="22.8353"
        width="3.03077"
        height="3.03077"
        transform="rotate(-24.7154 27.9448 22.8353)"
        stroke="#7B8CA8"
        strokeWidth="1.2"
      />
      <rect
        x="53.7065"
        y="33.443"
        width="3.03077"
        height="3.03077"
        transform="rotate(-24.7154 53.7065 33.443)"
        stroke="#7B8CA8"
        strokeWidth="1.2"
      />
      <rect
        x="67.3447"
        y="13.743"
        width="3.03077"
        height="3.03077"
        transform="rotate(-24.7154 67.3447 13.743)"
        stroke="#7B8CA8"
        strokeWidth="1.2"
      />
      <rect
        x="74.9219"
        y="54.6584"
        width="3.03077"
        height="3.03077"
        transform="rotate(-24.7154 74.9219 54.6584)"
        stroke="#7B8CA8"
        strokeWidth="1.2"
      />
      <rect
        x="70.3755"
        y="66.7814"
        width="3.03077"
        height="3.03077"
        transform="rotate(-24.7154 70.3755 66.7814)"
        stroke="#7B8CA8"
        strokeWidth="1.2"
      />
      <rect
        x="77.9526"
        y="78.9045"
        width="3.03077"
        height="3.03077"
        transform="rotate(-24.7154 77.9526 78.9045)"
        stroke="#7B8CA8"
        strokeWidth="1.2"
      />
      <rect
        x="82.4985"
        y="62.2353"
        width="3.03077"
        height="3.03077"
        transform="rotate(-24.7154 82.4985 62.2353)"
        stroke="#7B8CA8"
        strokeWidth="1.2"
      />
    </svg>
  )
}

export default BigIconSuccess
